import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'

class FilterSite extends Component {
  onChange = value => {
    if (value) {
      const { setMyJobsDataViewerFilter } = this.props

      setMyJobsDataViewerFilter({ site: value.index })
    }
  }

  render() {
    const { activeSite, siteList } = this.props

    return (
      <SelectList
        name="site"
        value={activeSite}
        list={siteList}
        variant="outlined"
        label={formatMessage('site')}
        onChange={this.onChange}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

FilterSite.defaultProps = {
  activeSite: 0,
  siteList: List([]),
}

FilterSite.propTypes = {
  activeSite: PropTypes.number,
  siteList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeSite: store.getIn(['profile', 'jobsDataViewerFilters', 'site']),
    siteList: store.getIn(['myJobsDataViewer', 'filters', 'sites']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterSite)
